const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  all: [],
  error: null,
  nbResult: 0
};
export const webtoolsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_WEBTOOLS": {
      return { ...initialState };
    }

    case "FETCH_WEBTOOLS_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }

    case "SET_FETCHING": {
      return { ...state, fetching: action.fetching };
    }

    case "ADD_WEBTOOLS": {
      let help = [...state.items];
      help.push(action.webtool);
      return { ...state, items: [...help] };
    }

    case "REMOVE_WEBTOOLS": {
      return {
        ...state,
        items: state.items.filter(
          item => parseInt(item.id, 10) !== parseInt(action.webtoolId, 10)
        )
      };
    }

    case "FETCH_WEBTOOLS_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: [...data],
        all: [...data],
        nbResult: nbResult
      };
    }

    case "FETCH_WEBTOOLS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    case "ADD_TO_WEBTOOLS": {
      const { favorite } = action;
      if (!favorite) {
        return state;
      }
      let helpItem = [...state.items];
      helpItem.unshift(favorite);

      let helpAll = [...state.all];
      helpAll.unshift(favorite);

      return { ...state, items: [...helpItem], all: [...helpAll] };
    }

    case "REDUCE_WEBTOOLS": {
      const { favorites } = action;
      if (!favorites || favorites.length === 0) {
        return state;
      }

      return {
        ...state,
        items: [...state.items].filter(item => {
          for (let i = 0; i < favorites.length; i++) {
            if (favorites[i].id === item.id) {
              return false;
            }
          }
          return true;
        }),
        all: [...state.all].filter(item => {
          for (let i = 0; i < favorites.length; i++) {
            if (favorites[i].id === item.id) {
              return false;
            }
          }
          return true;
        })
      };
    }

    case "FILTER_WEBTOOLS": {
      const { filter } = action;

      const { categoryId, search, lng } = filter;
      let help = [];

      if (!categoryId && !search) {
        help = [...state.all];
      } else {
        if (categoryId) {
          help = [
            ...state.all.filter(
              item =>
                parseInt(item.category.id, 10) === parseInt(categoryId, 10)
            )
          ];
        }

        if (search) {
          const searchLower = search.toLowerCase();

          const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
          const titleAttr = `title${lng.charAt(0).toUpperCase() +
            lng.slice(1)}`;
          const urlAttr = `urlName${lng.charAt(0).toUpperCase() +
            lng.slice(1)}`;
          const descAttr = `description${lng.charAt(0).toUpperCase() +
            lng.slice(1)}`;

          help = [
            ...(categoryId ? help : state.all).filter(
              item =>
                item[titleAttr].toLowerCase().indexOf(searchLower) !== -1 ||
                item[urlAttr].toLowerCase().indexOf(searchLower) !== -1 ||
                item[descAttr].toLowerCase().indexOf(searchLower) !== -1 ||
                (item.tags &&
                  item.tags.filter(
                    tag =>
                      tag[nameAttr].toLowerCase().indexOf(searchLower) !== -1
                  ).length > 0)
            )
          ];
        }
      }

      return { ...state, items: [...help] };
    }

    default:
      return state;
  }
};

const initialFavoritesState = {
  fetching: false,
  fetched: false,
  items: [],
  all: [],
  error: null,
  nbResult: 0,
  minusActivated: false,
  plusActivated: false
};
export const webtoolsFavoritesReducer = (
  state = initialFavoritesState,
  action
) => {
  switch (action.type) {
    case "CLICK_MINUS": {
      return { ...state, minusActivated: !state.minusActivated };
    }

    case "CLICK_PLUS": {
      return { ...state, plusActivated: !state.plusActivated };
    }

    case "SET_FETCHING": {
      return { ...state, fetching: action.fetching };
    }

    case "RESET_WEBTOOLS_FAVORITES": {
      return { ...initialFavoritesState };
    }

    case "ADD_TO_FAVORITES_REDUCER": {
      const { favorite } = action;
      if (!favorite) {
        return state;
      }
      let help = [...state.items];
      help.unshift(favorite);

      let helpAll = [...state.all];
      helpAll.unshift(favorite);

      return { ...state, items: [...help], all: [...helpAll] };
    }

    case "REMOVE_FROM_FAVORITES_REDUCER": {
      const { favorite } = action;
      if (!favorite) {
        return state;
      }
      return {
        ...state,
        items: state.items.filter(item => item.id !== favorite.id),
        all: state.all.filter(wt => wt.id !== favorite.id)
      };
    }

    case "FILTER_WEBTOOLS": {
      const { filter } = action;

      const { categoryId, search, lng } = filter;
      let help = [];

      if (!categoryId && !search) {
        help = [...state.all];
      } else {
        if (categoryId) {
          help = [
            ...state.all.filter(
              item =>
                parseInt(item.category.id, 10) === parseInt(categoryId, 10)
            )
          ];
        }

        if (search) {
          const searchLower = search.toLowerCase();

          const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
          const titleAttr = `title${lng.charAt(0).toUpperCase() +
            lng.slice(1)}`;
          const urlAttr = `urlName${lng.charAt(0).toUpperCase() +
            lng.slice(1)}`;
          const descAttr = `description${lng.charAt(0).toUpperCase() +
            lng.slice(1)}`;

          help = [
            ...(categoryId ? help : state.all).filter(
              item =>
                item[titleAttr].toLowerCase().indexOf(searchLower) !== -1 ||
                item[urlAttr].toLowerCase().indexOf(searchLower) !== -1 ||
                item[descAttr].toLowerCase().indexOf(searchLower) !== -1 ||
                (item.tags &&
                  item.tags.filter(
                    tag =>
                      tag[nameAttr].toLowerCase().indexOf(searchLower) !== -1
                  ).length > 0)
            )
          ];
        }
      }

      return { ...state, items: [...help] };
    }

    case "FETCH_WEBTOOLS_FAVORITES_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_WEBTOOLS_FAVORITES_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        errorFavorites: null,
        items: [...data],
        all: [...data],
        nbResult: nbResult
      };
    }
    case "FETCH_WEBTOOLS_FAVORITES_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};
const initialCategoriesState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0
};
export const webtoolsCategoriesReducer = (
  state = initialCategoriesState,
  action
) => {
  switch (action.type) {
    case `RESET_WEBTOOLS_CATEGORIES`: {
      return initialCategoriesState;
    }
    case `FETCH_WEBTOOLS_CATEGORIES_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_WEBTOOLS_CATEGORIES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case `FETCH_WEBTOOLS_CATEGORIES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
        items: [],
        nbResult: 0
      };
    }
    default:
      return state;
  }
};

const initialFilterState = { categoryId: null, search: null, lng: "en" };

export const webtoolsFilterReducer = (state = initialFilterState, action) => {
  switch (action.type) {
    case "SET_FILTER_CATEGORY": {
      return {
        ...state,
        categoryId: action.categoryId
      };
    }
    case "SET_FILTER_SEARCH": {
      return {
        ...state,
        search: action.search,
        lng: action.lng
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/webtool.js